import getGeneralImage from '../../util/getGeneralImage';

/**
 * @function getIconSize - To get size of tileArrowIcon
 * @param {boolean} tileIcon - Boolean indicating wheather tile icon is present
 * @param {boolean} sm - Boolean for indicating small screen size
 * @returns {number} Icon size in pixels based on screen size
 */
export const getIconSize = (tileIcon, sm) => {
  if (tileIcon) return 32;
  return sm ? 70 : 60;
};
/**
 * @function getBannerImage -Function to get relevent banner images
 * @param {*} props - Strapi Data
 * @returns {string} - Responsive images based on desktop,mobile and tablet view
 */
export const getBannerImage = props => {
  const infoTileMobile = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileBackground',
      view: 'MobileViewImage',
    }).url
  }`;
  const infoTileTablet = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileBackground',
      view: 'TabletViewImage',
    }).url
  }`;
  const infoTileDesktop = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileBackground',
      view: 'DesktopViewImage',
    }).url
  }`;
  const infoTileForegroundDesktop = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileForeground',
      view: 'DesktopViewImage',
    }).url
  }`;
  const infoTileForegroundTablet = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileForeground',
      view: 'TabletViewImage',
    }).url
  }`;
  const infoTileForegroundMobile = `${
    getGeneralImage({
      generalImageArray: props.cmsData?.Info_Tile_Images,
      key: 'tileForeground',
      view: 'MobileViewImage',
    }).url
  }`;
  return {
    infoTileMobile,
    infoTileDesktop,
    infoTileTablet,
    infoTileForegroundDesktop,
    infoTileForegroundMobile,
    infoTileForegroundTablet,
  };
};
